module.exports = __webpack_public_path__ + "img/track-icon.d6a36643.svg";